<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dL02k2/tc-custom/9781460307045.jpg?1730288488279" alt="This image is the cover for the book Run, Hide, Brothers in Arms: Fully Engaged"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Run, Hide, Brothers in Arms: Fully Engaged
      </h1>
      <p class="bookDescription body article font2">
        <b>First in a series featuring sexy spies, women in peril, and breathtaking romantic suspense from the author of the Red, White and Built thrillers.</b><br/><br/><i>If they ever find you, run . . . </i><br/><br/>Those are the words Jenna Stark has lived by for three years. But now the stakes are much higher. Her child is in danger and only one man can keep them alive. The man who forced her into a life on the run: her husband.<br/><br/>Cade Stark curses the day he was recruited for a covert ops organization—and the perilous assignment that tore the Navy SEAL from his new wife’s side. Cade’s only mission now is to protect Jenna and their young son. On the run from a vengeance-seeking arms dealer, desire reignites, hot and unstoppable. That’s when Cade realizes how much he’ll risk to win back Jenna’s trust. And how far he’ll go to offer his son a future.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Ericson
      </h2>
      
      <p class="authorDescription body article">Carol Ericson lives in southern California, home of state-of&ndash;the-art cosmetic surgery, wild freeway chases, and a million amazing stories. These stories, along with hordes of virile men and feisty women clamor for release from Carol&rsquo;s head until she sets them free to fulfill their destinies and her readers&rsquo; fantasies. To find out more about Carol and her current books, please visit her website at www.carolericson.com, &ldquo;where romance flirts with danger.&rdquo;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?319359b4